const _ = require('lodash');
const ariaLiveActions = require('swa-accessibility/aria-live-actions');
const CorporateLandingHomePageChangeCancelSelector = require('./corporate-landing-home-page-change-cancel-selector');
const corporateLoginConstants = require('swa-corporate-login/defines/corporate-login-constants.corporate');
const corporateLoginLibrary = require('swa-corporate-login/corporate-login-library.corporate');
const corporateLoginServerErrors = require('swa-corporate-login/defines/corporate-login-server-errors.corporate');
const customerStore = require('swa-customer/customer-store').instance;
const i18n = require('swa-locale/i18n');
const RapidRewardsLoginForm = require('swa-corporate-login/rapid-rewards-login-form.corporate');
const PropTypes = require('prop-types');
const React = require('react');
const serviceCaller = require('swa-service/service-caller');
const TransitionContent = require('swa-components-core/transition-content');

class CorporateLandingHomePageChangeLogin extends React.Component {
    static propTypes = {
        cancelFormProps: PropTypes.shape({
            formData: PropTypes.object,
            formType: PropTypes.string,
            hideRequiredIndicator: PropTypes.bool,
            onFormUpdated: PropTypes.func,
            onValidFormSubmitted: PropTypes.func,
            searching: PropTypes.bool,
            width: PropTypes.string
        }).isRequired,
        changeFormProps: PropTypes.shape({
            formData: PropTypes.object,
            formType: PropTypes.string,
            hideRequiredIndicator: PropTypes.bool,
            onFormUpdated: PropTypes.func,
            onValidFormSubmitted: PropTypes.func,
            searching: PropTypes.bool,
            width: PropTypes.string
        }).isRequired
    };

    state = {
        companyId: null,
        forcedLoginContentPhases: 'enter-from-right',
        loginStep: corporateLoginConstants.INDEX_STEP,
        rapidRewardRequired: false,
        serverError: ''
    };

    formRef = null;

    render() {
        return (
            <TransitionContent {...this.getTransitionContentProps()}>
                {this.renderContent()}
            </TransitionContent>
        );
    }

    renderContent = () => {
        let component;

        if (this.isIndexPageVisible()) {
            component = <CorporateLandingHomePageChangeCancelSelector {...this.getChangeCancelSelectorProps()} />;
        } else {
            component = <RapidRewardsLoginForm {...this.getRapidRewardsProps()} />;
        }

        return component;
    };

    renderRapidRewardsFormDescription = () => {
        const description = 'TEXT__RAPID_REWARDS_FORM_DESCRIPTION';

        return (
            <span>
                {i18n(description, { part: 1 })}
                <sup>{`${i18n('TEXT__REGISTERED')} `}</sup>
                {i18n(description, { part: 2 })}
            </span>
        );
    };

    getTransitionContentProps = () => ({
        className: 'corporate-landing-home-page-change-login--transition-content',
        onTransitionEnd: this.handleTransitionEnd,
        phases: this.state.forcedLoginContentPhases,
        transitionContentChanges: true
    });

    getChangeCancelSelectorProps = () => {
        const { cancelFormProps } = this.props;

        return {
            cancelFormProps,
            changeFormProps: this.getChangeFormProps()
        };
    };

    getRapidRewardsProps = () => ({
        className: 'corporate-landing-home-page-change-login--rapid-rewards-login',
        companyId: this.state.companyId,
        descriptionContent: this.renderRapidRewardsFormDescription(),
        headingContent: i18n('LABEL__CHANGE_FLIGHT'),
        interstitial: false,
        onLoginSuccess: this.handleChangeLoginSuccess,
        onTryDifferentCompanyId: this.handleTryDifferentCompanyIdForRapidRewardsForm,
        rapidRewardsRequired: this.state.rapidRewardRequired,
        ref: this.setFormRef
    });

    getChangeFormProps = () => {
        const changeFormProps = _.clone(this.props.changeFormProps);
        const { state } = this;

        _.assign(changeFormProps, {
            error: state.error,
            onValidFormSubmitted: this.handleValidFormSubmitted,
            searching: state.isLoading,
            serverError: state.serverError
        });

        return changeFormProps;
    };

    isIndexPageVisible = () => (this.state.loginStep === corporateLoginConstants.INDEX_STEP);

    handleTryDifferentCompanyIdForRapidRewardsForm = () => {
        this.setState({
            forcedLoginContentPhases: 'enter-from-left',
            loginStep: corporateLoginConstants.INDEX_STEP
        });
    };

    handleTransitionEnd = () => {
        if (this.state.loginStep === corporateLoginConstants.RAPID_REWARDS_STEP) {
            this.formRef.setFocusOnField('username');
        } else {
            ariaLiveActions.say(i18n('TITLE__CHANGE_OR_CANCEL'));
        }
    };

    setFormRef = (node) => {
        this.formRef = node;
    };

    handleValidFormSubmitted = (formData) => {
        const loginFormData = {
            companyId: formData.LandingAirReservationSearchForm_companyId_change
        };

        this.clearServerError();

        this.shouldActivateLoading(true);

        return serviceCaller({
            data: loginFormData,
            errorTarget: null,
            onDone: this.handleChangeLoginSuccess,
            onFail: this.handleChangeLoginFail,
            serviceName: 'CorporateTravelerLoginService'
        });
    };

    handleChangeLoginSuccess = (response) => {
        const { changeFormProps } = this.props;

        corporateLoginLibrary.handleStorage(
            { ...response, contextInformation: customerStore.UNSAFE_getDecodedIdToken().apiContext }
        );

        changeFormProps.onValidFormSubmitted(changeFormProps.formData);

        this.shouldActivateLoading(false);
    };

    handleChangeLoginFail = (error) => {
        const { changeFormProps } = this.props;
        const errorCode = _.get(error, 'responseJSON.code');
        const errorMessage = corporateLoginServerErrors.getErrorMessage(errorCode);
        const errorName = this.getErrorName(errorMessage);
        const { formData } = changeFormProps;

        if (!_.isEmpty(errorName)) {
            this.handleChangeLoginError(errorMessage, formData);
            this.shouldActivateLoading(false);
        } else {
            changeFormProps.onValidFormSubmitted(formData);
        }
    };

    handleChangeLoginError = (errorMessage, formData) => {
        const errorName = this.getErrorName(errorMessage);
        let newState = {};

        if (_.isEqual(errorName, 'force-login')) {
            newState = {
                companyId: formData.LandingAirReservationSearchForm_companyId_change,
                forcedLoginContentPhases: 'enter-from-right',
                loginStep: corporateLoginConstants.RAPID_REWARDS_STEP,
                rapidRewardRequired: true
            };
        } else {
            newState = this.setCompanyIdError(errorMessage, errorName);
        }

        this.setState(newState);
    };

    getErrorName = (errorMessage) => {
        const errorName = {
            'ANONYMOUS_NOT_ALLOWED': 'force-login',
            'COMPANY_DEACTIVATED': `ERROR__LOGIN_SERVER__${errorMessage}`,
            'COMPANY_ID_INVALID_CODE': 'VALIDATION__COMPANY_ID_NUMBER__DOES_NOT_MATCH',
            'COMPANY_ID_NOT_FOUND_CODE': 'VALIDATION__COMPANY_ID_NUMBER__DOES_NOT_MATCH'
        };

        return errorName[errorMessage];
    };

    setCompanyIdError = (errorMessage, errorName) => {
        let newState = {
            error: { 'LandingAirReservationSearchForm_companyId_change': [errorName] },
            serverError: ''
        };

        if (this.isServerError(errorMessage)) {
            newState = {
                error: {},
                serverError: errorName
            };
        }

        return newState;
    };

    isServerError = (errorMessage) => ('COMPANY_DEACTIVATED' === errorMessage);

    clearServerError = () => {
        this.setState({
            error: {},
            serverError: ''
        });
    };

    shouldActivateLoading = (isActive) => {
        this.setState({ isLoading: isActive });
    };
}

module.exports = CorporateLandingHomePageChangeLogin;
